export default __webpack_public_path__ + "static/media/Group 12506.aae9146c.svg";